import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'
import * as Yup from 'yup'
import { Field, Formik, FormikValues } from 'formik'

import { ProjectFormsProps } from '../types'
import { closeModal } from 'store/actions/modals'
import { MultiSelect, Form } from 'components/Forms'
import { ConfirmCancelButtons } from '../ConfirmCancelButtons'
import { useTags } from 'Api'
import { useProjectSubmit } from './hooks'

export const Clients: FC<ProjectFormsProps> = ({ type, projectIds }) => {
  const { data } = useTags()
  const { t } = useTranslation('legacy')
  const dispatch = useDispatch()
  const submitPositions = useProjectSubmit('clients')

  const { tagsById, tags } = data || {}

  if (type !== 'clients' || !tags || !tagsById) return null

  const clientTags = tags?.filter(tag => tag.type === 'clients')

  const handleSubmit = async (values: FormikValues) => {
    const clientsToSubmit = values.clients.map(clientId => tagsById[clientId])

    await submitPositions({ projectIds: projectIds, clients: clientsToSubmit, action: values.editMode })
    dispatch(closeModal())
  }

  return (
    <Formik
      validationSchema={Yup.object().shape({
        editMode: Yup.string(),
        clients: Yup.array()
      })}
      enableReinitialize={true}
      initialValues={{
        editMode: 'assign',
        clients: []
      }}
      onSubmit={handleSubmit}
    >
      {({ values, isSubmitting, dirty, ...actions }) => {
        const disableSubmit = values.clients.length === 0 || projectIds.length === 0
        return (
          <Form resetForm={actions.resetForm} dirty={!!dirty && !isSubmitting}>
            <ToggleEditMode />
            <MultiSelect
              module="manager.projects.bulkEdit"
              name="clients"
              isMulti
              placeholder={t('manager.projects.bulkEdit.DEFAULTSHIFTTAGS.PLACEHOLDER')}
              options={clientTags?.map(({ _id, name, icon }) => ({ label: name, value: _id, icon }))}
            />
            <ConfirmCancelButtons disabled={disableSubmit} isSubmitting={isSubmitting} />
          </Form>
        )
      }}
    </Formik>
  )
}

const ToggleEditMode = () => {
  const { t } = useTranslation('legacy')
  return (
    <div className="d-flex mb-2" role="group" aria-labelledby="toggleEdit">
      <label className="mr-2">
        <Field type="radio" name="editMode" value="assign" />
        {t('manager.projects.bulkEdit.ASSIGN')}
      </label>
      <label className="mr-2">
        <Field type="radio" name="editMode" value="unassign" />
        {t('manager.projects.bulkEdit.UNASSIGN')}
      </label>
    </div>
  )
}
